import { render, staticRenderFns } from "./ScanBodyWithHandles.vue?vue&type=template&id=18dbcc82&scoped=true&"
import script from "./ScanBodyWithHandles.vue?vue&type=script&lang=js&"
export * from "./ScanBodyWithHandles.vue?vue&type=script&lang=js&"
import style0 from "./ScanBodyWithHandles.vue?vue&type=style&index=0&id=18dbcc82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dbcc82",
  null
  
)

export default component.exports